import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { LayoutDashboard, User, LogOut, ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { base44 } from '@/api/base44Client';

// Compact dropdown for signed-in admins. Collapses the Admin Dashboard,
// My Account and Sign Out actions into a single clean chip so the navbar
// stays uncluttered for admin users.
export default function AdminNavMenu({ user }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, []);

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen((o) => !o)}
        className="flex items-center gap-2 text-sm text-white/70 hover:text-white transition-colors"
      >
        <span className="w-6 h-6 bg-primary/15 border border-primary/30 flex items-center justify-center">
          <LayoutDashboard className="w-3.5 h-3.5 text-primary" />
        </span>
        <span className="text-white font-medium">{user.full_name?.split(' ')[0] || 'Admin'}</span>
        <ChevronDown className={`w-3.5 h-3.5 text-white/40 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: -6 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -6 }}
            transition={{ duration: 0.15 }}
            className="absolute right-0 top-full mt-2 w-52 bg-[#111115] border border-white/10 shadow-xl py-1 z-50"
          >
            <Link
              to="/admin/dashboard"
              onClick={() => setOpen(false)}
              className="flex items-center gap-2.5 px-4 py-2.5 text-sm text-primary hover:bg-primary/10 transition-colors"
            >
              <LayoutDashboard className="w-3.5 h-3.5" />
              Admin Dashboard
            </Link>

            <Link
              to="/account"
              onClick={() => setOpen(false)}
              className="flex items-center gap-2.5 px-4 py-2.5 text-sm text-white/70 hover:bg-white/5 hover:text-white transition-colors"
            >
              <User className="w-3.5 h-3.5" />
              My Account
            </Link>
            <div className="border-t border-white/5 my-1" />
            <button
              onClick={() => { setOpen(false); base44.auth.logout('/'); }}
              className="w-full flex items-center gap-2.5 px-4 py-2.5 text-sm text-white/50 hover:bg-white/5 hover:text-white transition-colors text-left"
            >
              <LogOut className="w-3.5 h-3.5" />
              Sign Out
            </button>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}